'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.DataService', 'AVRO.Common.ProfileChart'];
module.exports = angular.module('AVRO.CompFaresChartControlsBoard', dependencies).controller('CompFaresChartControlsBoardController', require('./controllers/CompFaresChartControlsBoardController')).directive('rmCompFaresChartControlsBoard', require('./directives/CompFaresChartControlsBoardDirective'));